import React from 'react';
import PropTypes from 'prop-types';

import {BASE_FORM_MESSAGES} from '@constants/messages';
import {WATERMARKING} from '@constants/resources';
import Form from '@appComponents/ReduxFormControls';
import {GetEventContentWatermarkingFormOptions, GetEventContentWatermarking} from '@graphql/eventContentWatermarking/query';
import {
    CreateEventContentWatermarking, UpdateEventContentWatermarking, DeleteEventContentWatermarking,
} from '@graphql/eventContentWatermarking/mutation';
import {formatCidrsForDisplay} from '@modules/events/utils/eventContentWatermarkingCidrHelper';
import {IconInfoCircle} from '@appComponents/IconCollection';
import {CidrRangesInfoTooltip} from '@utils/CidrHelpers';

import validate from './validatorEventContentWatermarking';

export const SemanticTextAreaWitIcon = (props) => (
    <div className='textarea-wrapper --cidrsWithInfo'>
        <Form.SemanticTextArea
            {...props}
            defaultValue={formatCidrsForDisplay(props.defaultValue)}
        />
        <IconInfoCircle
            tooltip={<CidrRangesInfoTooltip />}
            hoverable
        />
    </div>
);

SemanticTextAreaWitIcon.propTypes = {
    defaultValue: PropTypes.string,
};

export default function EventContentWatermarkingModel(params = {}) {
    return {
        entityDataMapKey: 'eventContentWatermarking',
        entityLabel: 'watermarking configuration',
        label: 'watermarking configuration',
        formName: 'eventContentWatermarking',
        resources: WATERMARKING,
        showChangeLog: !!params.id,
        title: params.id
            ? 'Edit watermarking configuration'
            : 'Add new watermarking configuration',
        validate,
        messages: {
            boxName: {
                delete: 'eventWatermarkingMessage',
                error: 'eventWatermarkingMessage',
                success: 'eventWatermarkingMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'eventContentWatermarking.id',
                props: {
                    label: '',
                    name: 'id',
                    hidden: true,
                },
            },
            event_content: {
                dataMapKey: 'eventContentWatermarking.event_content.id',
                props: {
                    className: '--medium-width',
                    component: Form.SemanticSelect,
                    label: 'Content',
                    name: 'event_content',
                    required: true,
                },
            },
            cidrs: {
                dataMapKey: 'eventContentWatermarking.cidrs',
                props: {
                    component: SemanticTextAreaWitIcon,
                    label: 'CIDR ranges',
                    name: 'cidrs',
                    rows: 4,
                },
            },
            clients: {
                optionsKey: 'clients',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Clients',
                    name: 'clients',
                    multiple: true,
                    placeholder: 'Leave empty if you want to select all clients',
                },
            },
            description: {
                dataMapKey: 'eventContentWatermarking.description',
                props: {
                    component: Form.SemanticTextArea,
                    label: 'Description',
                    name: 'description',
                    rows: 3,
                },
            },
        },
        mutation: {
            createEntity: CreateEventContentWatermarking,
            updateEntity: UpdateEventContentWatermarking,
            deleteEntity: DeleteEventContentWatermarking,
        },
        query: {
            getOptions: GetEventContentWatermarkingFormOptions,
            getEntity: GetEventContentWatermarking,
        },
    };
}
